/**
 * Filename: language
 * Created Date:2021/9/6
 * Author: pyh
 * 
 * 
 * Copyright (c) 2021 Your Company
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '../store';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import Element from 'element-ui';

let zh = require('./zh.json');
let en = require('./en.json');

Vue.use(VueI18n);
const locales = {
    zh: Object.assign(zh, zhLocale),
    en: Object.assign(en, enLocale)
};
let lang = window.localStorage.getItem('language');
const i18n = new VueI18n({
    locale: lang,
    messages: locales,
});
Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value),
});

export default i18n;